import {
  ApiResponseErrorItem,
  ApiResponseErrorSchema,
} from "shared/network/apiResponseSchema";
import { ErrorCodesType, generalErrorCodes } from "./generalErrorCodes";
import HandledErrors from "./handledErrors";
import i18next from 'i18next';

export const getParsedStandardApiErrors = (input: unknown) => {
  const parsedResponse = ApiResponseErrorSchema.safeParse(input);
  if (parsedResponse.success && parsedResponse.data.success === false) {
    return parsedResponse.data;
  }
  return null;
};

export const getHandledErrorsFromRequestResult = (
  error: unknown,
  endpointErrorCodes?: ErrorCodesType
) => {
  const handledErrors = new HandledErrors();
  const parsedErrors = getParsedStandardApiErrors(error);

  const addToHandledErrors = (
    errorItem: ApiResponseErrorItem,
    errorCodes: ErrorCodesType
  ) => {
    if (errorCodes[errorItem.errorCode]) {
      const message = errorCodes[errorItem.errorCode].translation(i18next.t);
      if (errorItem.path) {
        handledErrors.addMessageWithPath(
          Array.isArray(errorItem.path) ? errorItem.path : [errorItem.path],
          message
        );
      } else {
        handledErrors.addMessageWithoutPath(message);
      }
    } else {
      handledErrors.addUnknownError(errorItem);
    }
  };

  parsedErrors?.errors.forEach((item) => {
    addToHandledErrors(item, endpointErrorCodes ?? generalErrorCodes);
  });
  return handledErrors;
};
